import { render } from "./letter-compose-step3.vue?vue&type=template&id=d63f5256"
import script from "./letter-compose-step3.vue?vue&type=script&lang=js"
export * from "./letter-compose-step3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__